import { RecentJudgeListPresenter } from '@/presentation/presenters/judge/recentJudgeListPresenter'
import { RecentJudgeListViewModel } from '@/presentation/viewmodels/judge/recentJudgeListViewModel'

export function useRecentJudgeListPresenter(
  presenter: RecentJudgeListPresenter = new RecentJudgeListPresenter(new RecentJudgeListViewModel())
) {
  return {
    recentJudgeList: presenter.recentJudgeList,
    isLoading: presenter.isLoading,
    error: presenter.error,
    getRecentJudgeResultList: presenter.getRecentJudgeResultList.bind(presenter)
  }
}
